import { configureStore } from "@reduxjs/toolkit";
import * as User from "./user";
import * as Setting from "./setting";
import * as Admin from "./admin";

// RTK's configureStore wires the thunk middleware and Redux DevTools by default.
// The former react-router-redux `routing` reducer/middleware was removed — routing
// now lives entirely in react-router v6 via the standalone history object.
export default function makeStore(initialState) {
  return configureStore({
    reducer: {
      currentUser: User.reducer,
      setting: Setting.reducer,
      admin: Admin.reducer,
    },
    preloadedState: initialState,
  });
}
